import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Seo from '../../components/SeoComponent/Seo';
import { AddProduct, fetchProducts, retrieveProduct } from '../../services/ListProduct/ListProduct';
import { showErrorToast, showSuccessToast } from '../../utils/toastUtils';
import Loader from '../../components/Loader/Loader';
import ReportHeading from '../Components/ReportHeadings/ReportHeadings';
import ProductEditModal from './ProductEditModal';
import HeadingTag from '../Components/HeadingComponent/HeadingTag';
import Button from '../Components/ButtonComponent/Button';
import moment from 'moment/moment';
import { FaEdit } from "react-icons/fa";
import 'react-quill/dist/quill.snow.css';
import { FaEye } from "react-icons/fa";
import InputWithLabel from '../Components/InputComponent/InputWithLabel';
import { IoIosCopy } from "react-icons/io";

const ProductList = () => {
    const [selectedId, setSelectedId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [lastPage, setLastPage] = useState(1);
    const [paginationData, setPaginationData] = useState();
    const [productData, setProductData] = useState([]);
    const [formData, setFormData] = useState({
        name: '',
    });
    const [errors, setErrors] = useState({});

    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleEditClick = (id) => {
        setSelectedId(id);
        setIsModalOpen(true);
    };

    useEffect(() => {
        loadProduct();
    }, [currentPage]);

    const loadProduct = async (page = currentPage) => {
        setIsLoading(true);
        try {
            const response = await fetchProducts(page);
            setProductData(response?.data);
            setPaginationData(response?.pagination);
            setCurrentPage(response?.pagination?.current_page);
            setLastPage(response?.pagination?.last_page);
        } catch (error) {
            console.error('Error Fetching Product:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const validate = (values) => {
        let errors = {};
        if (!values.name) errors.name = 'Product Name is required';
        return errors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    }

    const handleSubmit = async () => {
        const validationErrors = validate(formData);
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const payload = {
            name: formData.name,
        };

        try {
            const response = await AddProduct(payload);

            if (response?.status.code === 201 || response?.status.code === 200) {
                showSuccessToast(response.status.message)
                loadProduct();
                setFormData({ name: '' });
                return;
            } else {
                showErrorToast( response.status.error ||'Failed to add Product');
            }
        } catch (error) {
            console.error('Error adding Product:', error);
            showErrorToast('Failed to Add Product.');
        }
    };

    const handleUpdate = () => {
        loadProduct();
    };

    const handleCopy = (RefId) => {
        if (!RefId) {
            showErrorToast('Reference Key is Not available to copy!');
            return;
        }

        // Create a temporary textarea to copy the text
        const tempTextarea = document.createElement('textarea');
        tempTextarea.value = RefId;
        document.body.appendChild(tempTextarea);
        tempTextarea.select();
        document.execCommand('copy');
        document.body.removeChild(tempTextarea);
        // Show success message
        showSuccessToast('Copied to clipboard!');
    };


    return (
        <motion.div initial={{ opacity: 0, y: -50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1.2 }}>
            {isLoading && <Loader />}
            <Seo />
            <div className="mt-5 bg-white p-2">
                <ReportHeading name="Product" />
                {/* Form Section */}
                <div className="flex justify-center">
                    <InputWithLabel
                        DivclassName="md:w-1/4"
                        label="Product Name"
                        type="text"
                        name="name"
                        placeholder="Enter Product Name"
                        value={formData.name}
                        onChange={handleChange}
                        error={errors.name}
                    />
                </div>

                <div className="flex justify-center md:mt-2 mt-2">
                    <Button
                        className="text-center text-white bg-blue-700 shadow-lg bg-gradient-to-r from-blue-900
                         via-teal-400 to-purple-900 font-semibold p-0 rounded-md px-2 py-1 text-lg hover:bg-red-300"
                        type="submit" onClick={handleSubmit}>
                        Submit
                    </Button>
                </div>

                {/* Report Section */}
                <HeadingTag className="text-2xl text-blue-800 font-bold bg-white text-center mt-2" text="Report" />
                <div className="overflow-x-auto my-1 p-1">

                    <div className="container mx-auto p-1">

                        <div className="hidden lg:block">
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead className="text-md">
                                    <tr className="bg-blue-800 text-white text-center">
                                        <th className="border-2 p-2">S No.</th>
                                        <th className="border-2">Product Name</th>
                                        <th className='border-2'>Reference Key</th>
                                        <th className="border-2">Created At</th>
                                        <th className="border-2">Updated At</th>
                                        <th className="border-2">Edit</th>
                                    </tr>
                                </thead>
                                <tbody className="text-center">
                                    {productData?.length > 0 ? (
                                        productData.map((item, index) => (
                                            <tr
                                                key={(currentPage - 1) * (lastPage) + index + 1}
                                            >
                                                <td className="border shadow-inner shadow-blue-400 p-1 font-bold">
                                                    {(currentPage - 1) * (paginationData?.per_page || 0) + index + 1}
                                                </td>
                                                <td className="border shadow-inner shadow-blue-400 px-1">
                                                    <div dangerouslySetInnerHTML={{ __html: item.name }} />
                                                </td>
                                                <td className="border shadow-inner shadow-blue-400 p-1">
                                                    <div className="flex row justify-evenly">
                                                        {item?.reference_key}
                                                        <IoIosCopy onClick={() => handleCopy(item?.reference_key)} size={20} />
                                                    </div>
                                                </td>
                                                <td className="border shadow-inner shadow-blue-400 p-1">
                                                    {moment(item?.created_at).format('DD-MM-YYYY')}
                                                </td>
                                                <td className="border shadow-inner shadow-blue-400 p-1">
                                                    {moment(item?.updated_at).format('DD-MM-YYYY')}
                                                </td>
                                                <td className="border shadow-inner shadow-blue-400 p-1">
                                                    <div className="flex justify-center">
                                                        <FaEdit
                                                            size={20}
                                                            onClick={() => handleEditClick(item?.id)}
                                                            className="text-blue-700 hover:bg-white hover:text-green-600"
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="5" className="px-4 py-2 text-center text-xl">
                                                Data Not Found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <div className="block lg:hidden">
                            {productData?.length > 0 ? (
                                productData.map((item, index) => (
                                    <div
                                        key={(currentPage - 1) * (lastPage) + index + 1}
                                        className="border rounded-lg shadow-lg shadow-blue-500 mb-2 p-2 bg-gradient-to-r from-blue-100 via-white to-blue-50 transition-transform transform hover:scale-105"
                                    >

                                        <div className="flex justify-between items-center mb-1">
                                            <span className="font-bold text-gray-700">S No.:</span>
                                            <span className="text-blue-700 font-medium">
                                                {(currentPage - 1) * (paginationData?.per_page || 0) + index + 1}
                                            </span>
                                        </div>


                                        <div className="flex justify-between items-center mb-1">
                                            <span className="font-bold text-gray-700">Created At:</span>
                                            <span className="text-gray-600">
                                                {moment(item?.created_at).format('DD-MM-YYYY')}
                                            </span>
                                        </div>


                                        <div className="flex justify-between items-center">
                                            <span className="font-bold text-gray-700">Updated At:</span>
                                            <span className="text-gray-600">
                                                {moment(item?.updated_at).format('DD-MM-YYYY')}
                                            </span>
                                        </div>


                                        <div className="flex justify-center">
                                            <button
                                                onClick={() => handleEditClick(item?.id)}
                                                className="flex items-center justify-center w-12 h-10 rounded-full bg-blue-700 text-white hover:bg-green-500 transition-all duration-300"
                                            >
                                                <FaEdit size={24} />
                                            </button>
                                        </div>


                                        <div className="flex justify-between items-center mb-1">
                                            <span className="font-bold text-gray-700">Product Name:</span>
                                            <div className="text-gray-800" dangerouslySetInnerHTML={{ __html: item.name }} />
                                            {/* <FaEye /> */}
                                        </div>


                                        <div className='flex justify-between align-center mb-1'>
                                            <span className='font-bold text-gray-700'>Reference Key</span>
                                            {item?.reference_key}
                                            <IoIosCopy onClick={() => handleCopy(item?.reference_key)} size={20} />
                                        </div>

                                    </div>
                                ))
                            ) : (
                                <div className="text-center text-xl text-gray-500">Data Not Found</div>
                            )}
                        </div>
                    </div>

                    {isModalOpen && (
                        <ProductEditModal
                            isOpen={isModalOpen}
                            onClose={() => setIsModalOpen(false)}
                            productId={selectedId}
                            onUpdate={handleUpdate}
                        />
                    )}
                    <div className="gap-2 mt-3">
                        <div className="flex justify-center gap-3">
                            <button
                                className="py-1 text-xl rounded-md hover:bg-blue-800 px-4 bg-blue-500 text-white border-none cursor-pointer"
                                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                                disabled={currentPage === 1}
                            >
                                Prev
                            </button>
                            <button
                                className="py-1 text-xl rounded-md hover:bg-blue-800 px-4 bg-blue-900 text-white border-none cursor-pointer"
                                onClick={() =>
                                    setCurrentPage((prev) =>
                                        Math.min(prev + 1, paginationData?.last_page || 1)
                                    )
                                }
                                disabled={currentPage === paginationData?.last_page}
                            >
                                Next
                            </button>
                            <div className="flex justify-end">
                                <p className="text-[17px] font-bold">
                                    Page {currentPage} of {paginationData?.last_page || 1}
                                </p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </motion.div>
    );
};

export default ProductList;


